import { getOrderMangoCallsAsync } from 'services/mangoCallService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

export const SWR_ORDER_MANGO_CALLS_ENDPOINT = 'order-mango-calls';

type SWRData = Awaited<ReturnType<typeof getOrderMangoCallsAsync>>;

const useOrderMangoCalls = (
  orderId: number,
  load = true
): SWRResponse<SWRData, AxiosError> =>
  useSWR(
    load ? [SWR_ORDER_MANGO_CALLS_ENDPOINT, orderId] : null,
    async ([_, id]) => await getOrderMangoCallsAsync(id)
  );

export default useOrderMangoCalls;
